export enum RestrictionOptions {
  AllUsers,
  VerifiedUsers,
}
export enum RestrictionLocationOptions {
  AllCountries,
  OnlyUS,
  ProhibitUS,
}
